import React, { Component } from 'react';
import { motion } from 'framer-motion';
import { MessageCircle } from 'lucide-react';
import { DollarTicker } from './DollarTicker';
export function Hero() {
  const handleWhatsApp = () => {
    const text = 'Hola, tengo aproximadamente USD y quisiera cotizar estos billetes. Adjunto fotos.';
    window.open(`https://wa.me/5491176110902?text=${encodeURIComponent(text)}`, '_blank');
  };
  return <section className="relative pt-32 pb-20 lg:pt-48 lg:pb-32 overflow-hidden bg-slate-50" data-id="element-60">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_var(--tw-gradient-stops))] from-blue-100/40 via-slate-50 to-slate-50" data-id="element-61"></div>
      <div className="absolute top-1/4 -left-64 w-96 h-96 bg-blue-200/50 rounded-full blur-3xl" data-id="element-62"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-63">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-64">
          <div className="max-w-3xl" data-id="element-65">
            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-[#0a2540] tracking-tight leading-[1.1] mb-6" data-id="element-66">
              Compramos tus dólares,{' '}
              <span className="text-blue-700" data-id="element-67">sin importar su estado.</span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="text-lg sm:text-xl text-slate-600 mb-10 leading-relaxed max-w-2xl" data-id="element-68">
              Compramos billetes manchados, rotos, escritos, quemados, con
              cintas o sellos y de todas las denominaciones (USD 1 a 100).
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="flex flex-col sm:flex-row gap-4" data-id="element-69">
              <button onClick={handleWhatsApp} className="flex items-center justify-center gap-2 px-8 py-4 text-base font-bold text-white bg-[#0a2540] rounded-full hover:bg-[#1a365d] transition-all duration-300 transform hover:scale-105 shadow-[0_0_20px_rgba(10,37,64,0.2)]" data-id="element-70">
                <MessageCircle className="w-5 h-5" data-id="element-71" />
                Cotizar por WhatsApp
              </button>

              <a href="#cotizacion-vivo" className="flex items-center justify-center gap-2 px-8 py-4 text-base font-semibold text-[#0a2540] bg-transparent border-2 border-slate-300 rounded-full hover:border-slate-400 hover:bg-slate-100 transition-all duration-300" data-id="element-72">
                Ver cotización en vivo
              </a>
            </motion.div>
          </div>

          {/* Live Dollar Ticker */}
          <div id="cotizacion-vivo" className="flex justify-center lg:justify-end scroll-mt-28" data-id="element-73">
            <DollarTicker data-id="element-74" />
          </div>
        </div>
      </div>
    </section>;
}